const ENGLISH_CARD_TITLES = {
  "ds-01": "LISS Panel",
  "ds-02": "ODISSEI Portal",
  "ds-03": "Interview Transcripts",
  "ds-04": "Public Social Media",
  "ds-05": "CBS Open Data",
  "ds-06": "Academic Literature",
  "ds-07": "Previous Interview Data",
  "ds-08": "Client Knowledge",
  "ds-09": "Customer Service Logs",
  "ds-10": "Survey Results",
  "ds-11": "Policy & Regulation",
  "ds-12": "Community Organizations",
  "ds-13": "Usability Test Logs",
  "ds-14": "Forum Discussions",
  "ds-15": "Service Blueprint Data",
  "ds-16": "Workshop Output",
  "ds-17": "Diary Studies",
  "ds-18": "Market and Trend Reports",
  "ds-19": "Sensor Data",
  "ds-20": "Field Notes",
  "bi-01": "Digital Literacy Bias",
  "bi-02": "Language and Literacy Bias",
  "bi-03": "Majority Group Bias",
  "bi-04": "Age Bias",
  "bi-05": "Confirmation Bias",
  "bi-06": "Recency Bias",
  "bi-07": "Availability Bias",
  "bi-08": "Survivorship Bias",
  "bi-09": "Social Desirability Bias",
  "bi-10": "Gender Bias",
  "bi-11": "Socioeconomic Bias",
  "bi-12": "Geographic Bias",
  "bi-13": "Accessibility Bias",
  "bi-14": "Context Bias",
  "bi-15": "Data Quality Bias",
  "rm-01": "Realistic",
  "rm-02": "Critical",
  "rm-03": "Exploratory",
  "rm-04": "Proactive",
  "rm-05": "Cautious",
  "rm-06": "Overwhelmed",
  "rm-07": "Emotionally Involved",
  "rm-08": "Indifferent",
  "rm-09": "Dependent on Help",
  "rm-10": "Distrustful",
};

export function getCardDisplayTitle(card, language = "nl") {
  if (!card) return "";
  if (language === "en" && ENGLISH_CARD_TITLES[card.id]) return ENGLISH_CARD_TITLES[card.id];
  return card.title || card.name || card.code || "";
}
